// 历史订单列表
import * as React from "react";
import Layout from "../Layout";
import Content from "./Content";
import { RootState } from "../../store/configureStore";
import InfoLayout from "../UserCenter/components/Layout";
import { useSelector } from "react-redux";
const AfterSale = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "首页",
      },
      {
        url: "/account/orders/213123123213123/22",
        title: "售后",
      },
    ],
  } = useSelector((state: RootState) => state.AfterSalePage);
  return (
    <Layout breadcrumbs={breadcrumbs}>
      <InfoLayout>
        <Content />
      </InfoLayout>
    </Layout>
  );
};

export default AfterSale;
